module.exports = __webpack_public_path__ + "2acb60f2/img/menu-icon.5f8facae.svg";